// import React, { useContext, useState, useEffect } from "react";
// import {
//     Box,
//     Card,
//     CardActions,
//     Container,
//     CssBaseline,
//     Stack,
//     Typography,
//     useTheme,
// } from "@mui/material";
// import EnergyReportingChart from "../../../../../../components/charts/energy_reporting/EnergyReportingChart";
// import AppModal from "../../../../../../components/AppModal";
// import { InverterContext } from "../../../../../../context/InverterContext";
// import MonthlySumFilterStrip from "./MonthlySumFilterStrip";




// function MonthlySumCurve() {
//     const getCurrentMonth = () => {
//         const now = new Date();
//         const year = now.getFullYear();
//         const month = String(now.getMonth() + 1).padStart(2, "0");
//         return `${year}-${month}`;
//     };

//     const { spacing } = useTheme();
//     const { monthlySumData, monthlySumLoading, monthlySumError, MonthlySumApi } = useContext(InverterContext);

//     const [startDate, setStartDate] = useState(getCurrentMonth());
//     const [endDate, setEndDate] = useState(getCurrentMonth());
//     const [chartData, setChartData] = useState([]);
//     const [chartLabels, setChartLabels] = useState([]);
//     const [open, setOpen] = useState(false);

//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);

//     const onRefreshData = () => {
//         if (startDate && endDate) {
//             const credentials = {
//                 LOGIN_ID: localStorage.getItem("LoginID") || "",
//                 PASS_KEY: localStorage.getItem("KEY") || "xyz",
//                 LCODE: localStorage.getItem("LCODE") || "",
//                 MT1: startDate,
//                 MT2: endDate,
//                 TYP: "A",
//                 WEB_KEY: "WEBXYZ321",
//                 FID: "216HT001",
//             };
//             MonthlySumApi(credentials);
//         } else {
//             alert("Please provide valid dates.");
//         }
//     };

//     // Utility function to get random color
//     const getRandomColor = () => {
//         const letters = "0123456789ABCDEF";
//         let color = "#";
//         for (let i = 0; i < 6; i++) {
//             color += letters[Math.floor(Math.random() * 16)];
//         }
//         return color;
//     };

//     // Process chart data when monthlyData updates
//     useEffect(() => {
//         if (monthlySumData) {
//             const processChartData = () => {
//                 const labels = [];
//                 const datasets = {};

//                 monthlySumData.forEach((singleData, index) => {
//                     console.log(`Processing Entry ${index + 1}:`, singleData);

//                     let chartKeys = Object.keys(singleData).filter(key =>
//                         key.toUpperCase().includes('KWH')
//                     );
//                     labels.push(singleData.MONTH || `Unknown-${index + 1}`);

//                     chartKeys.forEach((key) => {
//                         if (!datasets[key]) {
//                             datasets[key] = [];
//                         }
//                         datasets[key].push(singleData[key] || 0);
//                     });
//                 });

//                 const datasetArr = Object.keys(datasets).map((key) => ({
//                     label: key.replace("MONTH_Total_KWH", ""),
//                     data: datasets[key],
//                     borderColor: getRandomColor(),
//                     backgroundColor: getRandomColor(),
//                     tension: 0.3,
//                     borderWidth: 1,
//                     pointRadius: 2,
//                     pointHoverRadius: 3,
//                 }));

//                 if (datasetArr.length === 0) {
//                     datasetArr.push({
//                         label: "No Data",
//                         data: Array(labels.length).fill(0),
//                         borderColor: "#CCCCCC",
//                         backgroundColor: "#EEEEEE",
//                     });
//                 }

//                 setChartLabels(labels);
//                 setChartData(datasetArr);

//                 console.log("Processed Chart Labels:", labels);
//                 console.log("Processed Datasets:", datasetArr);
//             };

//             processChartData();
//         }
//     }, [monthlySumData]);

//     console.log("monthlysum",monthlySumData)

//     return (
//         <>
//             <CssBaseline />
//             <Box
//                 component={Stack}
//                 sx={{ bgcolor: "background.default", rowGap: spacing(1), py: spacing(1) }}
//             >
//                 <MonthlySumFilterStrip
//                     title="Monthly Energy Summary Curve"
//                     ValueOf1={startDate}
//                     ValueOf2={endDate}
//                     onChangeValueOf1={(e) => setStartDate(e.target.value)}
//                     onChangeValueOf2={(e) => setEndDate(e.target.value)}
//                     onFullScreen={handleOpen}
//                     onRefreshData={onRefreshData}
//                 />

//                 {monthlySumLoading ? (
//                     <Typography variant="body2" textAlign="center" color="primary.main">
//                         Data Loading...
//                     </Typography>
//                 ) : monthlySumError ? (
//                     <Typography variant="body2" textAlign="center" color="error.main">
//                         Error loading data: {monthlySumError.message}
//                     </Typography>
//                 ) : chartData.length === 0 ? (
//                     <Typography variant="body2" textAlign="center" color="black">
//                         No data available.
//                     </Typography>
//                 ) : (
//                     <>
//                         <Card>
//                             <CardActions>
//                                 <Container maxWidth={false}>
//                                     <EnergyReportingChart data={chartData} labels={chartLabels} />
//                                 </Container>
//                             </CardActions>
//                         </Card>
//                         <AppModal open={open} handleClose={handleClose}>
//                             <Box>
//                                 <Typography variant="h5" textAlign="center">
//                                     Monthly Energy Summary Curve
//                                 </Typography>
//                                 <Container maxWidth={false}>
//                                     <EnergyReportingChart data={chartData} labels={chartLabels} />
//                                 </Container>
//                             </Box>
//                         </AppModal>
//                     </>
//                 )}
//             </Box>
//         </>
//     );
// }

// export default MonthlySumCurve;




// 2.

// import React, { useEffect, useState } from "react";
// import {
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   LabelList,
//   Legend,
//   Brush, // Import Brush for zoom functionality
// } from "recharts";
// import { InverterDetail2, MonthlySumApi } from "../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material"; // Import icons
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress"; // Loading spinner
// import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";

// const MonthlySumCurve = () => {
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
//   const getCurrentMonth = () => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     return `${year}-${month}`;
//   };

//   // Function to get date six months ago
//   const getSixMonthsAgo = () => {
//     const now = new Date();
//     now.setMonth(now.getMonth() - 5); // Subtract 6 months
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     return `${year}-${month}`;
//   };

//   const [startDate, setStartDate] = useState(getSixMonthsAgo()); // 5 months ago
//   const [endDate, setEndDate] = useState(getCurrentMonth()); // Current month

//   const [logData, setLogData] = useState([]);
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID") || "",
//     PASS_KEY: localStorage.getItem("KEY") || "xyz",
//     LCODE: localStorage.getItem("LCODE") || "",
//     MT1: startDate,
//     MT2: endDate,
//     TYP: "A",
//     WEB_KEY: "WEBXYZ321",
//     FID: "216HT001",
//   };


//   const fetchLogData = async () => {
//     setLoading(true);
//     setError(null);
//     setLogData([]);

//     try {
//       const res = await MonthlySumApi(credentials);
//       if (res?.MONTH_SUM && Array.isArray(res?.MONTH_SUM)) {
//         setLogData(res?.MONTH_SUM);
//         setTotalPages(Math.ceil(res?.MONTH_SUM.length / rowsPerPage));

//         // const transformedData = res.data.map((item) => ({
//         //   MONTH: item.MONTH, // Replace with appropriate key for labels
//         //   Plant_Total_KWH_Cumulative:parseFloat(item.Plant_Total_KWH_Cumulative) || 0, // Replace with the key for peak KW
//         //   MONTH_Total_KWH:parseFloat(item.MONTH_Total_KWH) || 0, // Replace with the key for KWp
//         //   EXPECTED_KWH:parseFloat(item.EXPECTED_KWH) || 0, // Replace with the key for KW
//         //   MONTH_PR:parseFloat(item.MONTH_PR) || 0, // Add daily kWh
//         // }));
//         const transformedData = res.MONTH_SUM.map((item) => ({
//           MONTH: item.MONTH,
//           Plant_Total_KWH_Cumulative: parseFloat(item.Plant_Total_KWH_Cumulative) || 0,
//           MONTH_Total_KWH: parseFloat(item.MONTH_Total_KWH) || 0,
//           EXPECTED_KWH: parseFloat(item.EXPECTED_KWH) || 0,
//           MONTH_PR: parseFloat(item.MONTH_PR) || 0,
//         }));


//         setChartData(transformedData);

//       } else {
//         console.error("Invalid data structure:", res);
//         setLogData([]);
//       }
//     } catch (err) {
//       console.error("Error fetching data:", err);
//       setError("Failed to fetch data. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, [startDate, endDate]);


//   console.log("logDatamonthlysumcc", chartData)

//   return (
//     <>
//       <div className="row">
//         <div className="col-md-12" style={{ height: 480, position: "relative" }}>
//           {/* Refresh Button */}
//           <div style={{
//             marginBottom: "4px", cursor: "pointer",
//             position: "absolute",
//             top: "10px",
//             right: "10px",
//             zIndex: 1,
//             color: "#808080",
//             fontSize: "24px",
//           }}>
//             <IconButton onClick={fetchLogData} disabled={loading}>
//               <Refresh />
//             </IconButton>
//             {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//           </div>

//           {/* Chart */}
//           {loading ? (
//             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//               <CircularProgress />
//             </div>
//           ) : (
//             <ResponsiveContainer>
//               <ComposedChart
//                 data={chartData}
//                 margin={{ top: 20, right: 40, left: 40, bottom: 5 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="MONTH" />
//                 <YAxis yAxisId="left" />
//                 <YAxis yAxisId="right" orientation="right" />
//                 <Tooltip />

//                 {/* Add Legend */}
//                 <Legend
//                   layout="horizontal"
//                   verticalAlign="top"
//                   align="center"
//                   wrapperStyle={{
//                     paddingBottom: "10px", // Space between legend and chart
//                     fontSize: "12px", // Adjust font size
//                   }}
//                 />

//                 {/* Bars for Peak KW, KWp, and KW */}
//                 {/* <Bar dataKey="Plant_Total_KWH_Cumulative" fill="#808080" name="Plant_Total_KWH_Cumulative" yAxisId="left">
//                   <LabelList
//                     dataKey="Plant_Total_KWH_Cumulative"
//                     position="top"
//                     style={{ fill: "#808080", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar> */}
//                 <Line
//                   type="monotone"
//                   dataKey="Plant_Total_KWH_Cumulative"
//                   stroke="red"
//                   name="Plant_Total_KWH_Cumulative"
//                   yAxisId="left"
//                   strokeWidth={2}
//                 >
//                   <LabelList
//                     dataKey="Plant_Total_KWH_Cumulative"
//                     position="top"
//                     style={{ fill: "red", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Line>


//                 <Bar dataKey="MONTH_Total_KWH" fill={LoggedInUserInfo.dash_color} name="MONTH_Total_KWH" yAxisId="left">
//                   <LabelList
//                     dataKey="MONTH_Total_KWH"
//                     position="top"
//                     style={{ fill: LoggedInUserInfo.dash_color, fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>
//                 <Bar dataKey="EXPECTED_KWH" fill="#0000ff" name="EXPECTED_KWH" yAxisId="left">
//                   <LabelList
//                     dataKey="EXPECTED_KWH"
//                     position="top"
//                     style={{ fill: "#0000ff", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Bar>

//                 {/* Line for DAY_KWH with data labels */}
//                 <Line
//                   type="monotone"
//                   dataKey="MONTH_PR"
//                   stroke="green"
//                   name="MONTH_PR"
//                   yAxisId="right"
//                   strokeWidth={2}
//                 >
//                   <LabelList
//                     dataKey="MONTH_PR"
//                     position="top"
//                     style={{ fill: "green", fontSize: "12px", fontWeight: "bold" }}
//                   />
//                 </Line>

//                 {/* Brush Component for Zooming */}
//                 <Brush
//                   dataKey="name"
//                   height={30}
//                   stroke="#8884d8"
//                   startIndex={0}
//                   endIndex={10}
//                 />
//               </ComposedChart>
//             </ResponsiveContainer>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default MonthlySumCurve;



// 3 this 3 x-axis google graph

// import React from "react";
// import {
//   ResponsiveContainer,
//   ComposedChart,
//   Line,
//   Area,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
// } from "recharts";

// const data = [
//   { year: "2015", expenses: 10000, purchase: 50000, sales: 80000, profit: 10000 },
//   { year: "2016", expenses: 30000, purchase: 70000, sales: 120000, profit: 20000 },
//   { year: "2017", expenses: 50000, purchase: 90000, sales: 160000, profit: 25000 },
//   { year: "2018", expenses: 80000, purchase: 110000, sales: 180000, profit: 30000 },
//   { year: "2019", expenses: 90000, purchase: 130000, sales: 200000, profit: 40000 },
//   { year: "2020", expenses: 40000, purchase: 60000, sales: 100000, profit: 15000 },
// ];

// const MonthlySumCurve = () => {
//   return (
//     <div style={{ width: "100%", height: 400 }}>
//       <ResponsiveContainer>
//         <ComposedChart data={data}>
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="year" />

//           {/* Y-Axis for Expenses (Left) */}
//           {/* <YAxis
//             yAxisId="left"
//             orientation="left"
//             stroke="#28a745"
//             label={{ value: "Expenses", angle: -90, position: "insideLeft", fill: "#28a745" }}
//           /> */}

//           {/* Y-Axis for Expenses (Left) */}
//           <YAxis
//             yAxisId="left"
//             orientation="left"
//             stroke="#28a745"
//             label={{
//               value: "Expenses",
//               angle: -90,
//               position: "outsideLeft", // move label outside
//               offset: 10,
//               fill: "#28a745"
//             }}
//           />

//           {/* Y-Axis for Purchase (Right-middle) */}
//           <YAxis
//             yAxisId="middle"
//             orientation="right"
//             stroke="#ff7f0e"
//             label={{
//               value: "Purchase",
//               angle: -90,
//               position: "outsideRight", // move label outside
//               offset: 60, // push it away to avoid overlap with 'Sales/Profit'
//               fill: "#ff7f0e"
//             }}
//           />

//           {/* Y-Axis for Sales & Profit (Far Right) */}
//           <YAxis
//             yAxisId="right"
//             orientation="right"
//             stroke="#1f77b4"
//             label={{
//               value: "Sales / Profit",
//               angle: -90,
//               position: "outsideRight",
//               offset: 10,
//               fill: "#1f77b4"
//             }}
//             mirror={false}
//           />




//           <Tooltip />
//           <Legend />

//           {/* Expenses - Green Line */}
//           <Line yAxisId="left" type="monotone" dataKey="expenses" stroke="#28a745" name="Expenses" />

//           {/* Purchase - Orange Line */}
//           <Line yAxisId="middle" type="monotone" dataKey="purchase" stroke="#ff7f0e" name="Purchase" />

//           {/* Sales - Blue Area */}
//           <Area
//             yAxisId="right"
//             type="monotone"
//             dataKey="sales"
//             fill="#cce5ff"
//             stroke="#1f77b4"
//             name="Sales"
//           />

//           {/* Profit - Grey Line */}
//           <Line
//             yAxisId="right"
//             type="monotone"
//             dataKey="profit"
//             stroke="#666"
//             strokeDasharray="5 5"
//             name="Profit"
//           />
//         </ComposedChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default MonthlySumCurve;


// 4.

// import React, { useEffect, useState } from "react";
// import {
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   ComposedChart,
//   LabelList,
//   Legend,
//   Brush, // Import Brush for zoom functionality
// } from "recharts";
// import { InverterDetail2, MonthlySumApi } from "../../../../../../api/Api";
// import { Refresh } from "@mui/icons-material"; // Import icons
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress"; // Loading spinner
// import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";
// import "./MonthlySumCurve.css"

// const MonthlySumCurve = () => {
//   const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
//   const getCurrentMonth = () => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     return `${year}-${month}`;
//   };

//   // Function to get date six months ago
//   const getSixMonthsAgo = () => {
//     const now = new Date();
//     now.setMonth(now.getMonth() - 5); // Subtract 6 months
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     return `${year}-${month}`;
//   };

//   const [startDate, setStartDate] = useState(getSixMonthsAgo()); // 5 months ago
//   const [endDate, setEndDate] = useState(getCurrentMonth()); // Current month

//   const [logData, setLogData] = useState([]);
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);

//   const credentials = {
//     LOGIN_ID: localStorage.getItem("LoginID") || "",
//     PASS_KEY: localStorage.getItem("KEY") || "xyz",
//     LCODE: localStorage.getItem("LCODE") || "",
//     MT1: startDate,
//     MT2: endDate,
//     TYP: "A",
//     WEB_KEY: "WEBXYZ321",
//     FID: "216HT001",
//   };


//   const fetchLogData = async () => {
//     setLoading(true);
//     setError(null);
//     setLogData([]);

//     try {
//       const res = await MonthlySumApi(credentials);
//       if (res?.MONTH_SUM && Array.isArray(res?.MONTH_SUM)) {
//         setLogData(res?.MONTH_SUM);
//         setTotalPages(Math.ceil(res?.MONTH_SUM.length / rowsPerPage));
//         const transformedData = res.MONTH_SUM.map((item) => ({
//           MONTH: item.MONTH,
//           Plant_Total_KWH_Cumulative: parseFloat(item.Plant_Total_KWH_Cumulative) || 0,
//           MONTH_Total_KWH: parseFloat(item.MONTH_Total_KWH) || 0,
//           EXPECTED_KWH: parseFloat(item.EXPECTED_KWH) || 0,
//           MONTH_PR: parseFloat(item.MONTH_PR) || 0,
//         }));


//         setChartData(transformedData);

//       } else {
//         console.error("Invalid data structure:", res);
//         setLogData([]);
//       }
//     } catch (err) {
//       console.error("Error fetching data:", err);
//       setError("Failed to fetch data. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, [startDate, endDate]);


//   console.log("logDatamonthlysumcc", chartData)

//   return (
//     <>
//       <div className="row">
//         <div className="col-md-12" style={{ height: 480, position: "relative" }}>
//           {/* Refresh Button */}
//           <div style={{
//             marginBottom: "4px", cursor: "pointer",
//             position: "absolute",
//             top: "10px",
//             right: "10px",
//             zIndex: 1,
//             color: "#808080",
//             fontSize: "24px",
//           }}>
//             <IconButton onClick={fetchLogData} disabled={loading}>
//               <Refresh />
//             </IconButton>
//             {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//           </div>

//           {/* Chart */}
//           {loading ? (
//             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
//               <CircularProgress />
//             </div>
//           ) : (
//             <ResponsiveContainer>
//               <ComposedChart
//                 data={chartData}
//                 margin={{ top: 20, right: 80, left: 60, bottom: 20 }}
//               >
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="MONTH" />

//                 {/* Y-Axes */}
//                 <YAxis
//                   yAxisId="left"
//                   orientation="left"
//                   stroke="red"
//                   label={{
//                     value: "",
//                     angle: -90,
//                     position: "outsideLeft",
//                     fill: "red",
//                     offset: 10
//                   }}
//                 />
//                 <YAxis
//                   yAxisId="middle"
//                   orientation="right"
//                   stroke={LoggedInUserInfo.dash_color}
//                   label={{
//                     value: "",
//                     angle: -90,
//                     position: "outsideRight",
//                     offset: 60,
//                     fill: LoggedInUserInfo.dash_color,
//                   }}
//                 />
//                 <YAxis
//                   yAxisId="right"
//                   orientation="right"
//                   stroke="#0000ff"
//                   label={{
//                     value: "",
//                     angle: -90,
//                     position: "outsideRight",
//                     offset: 110,
//                     fill: "#0000ff",
//                   }}
//                 />
//                 <YAxis
//                   yAxisId="bottom"
//                   orientation="right"
//                   stroke="green"
//                   label={{
//                     value: "",
//                     angle: -90,
//                     position: "outsideRight",
//                     offset: 160,
//                     fill: "green",
//                   }}
//                 />

//                 <Tooltip />
//                 <Legend verticalAlign="top" height={36} />

//                 {/* Render Bars first so lines come on top */}
//                 <Bar
//                   yAxisId="middle"
//                   dataKey="MONTH_Total_KWH"
//                   fill={LoggedInUserInfo.dash_color}
//                   name="MONTH_Total_KWH"
//                 >
//                   <LabelList dataKey="MONTH_Total_KWH" position="top" style={{ fill: LoggedInUserInfo.dash_color, fontSize: 12, fontWeight: "bold" }} />
//                 </Bar>

//                 <Bar
//                   yAxisId="right"
//                   dataKey="EXPECTED_KWH"
//                   fill="#0000ff"
//                   name="Expected KWH"
//                 >
//                   <LabelList dataKey="EXPECTED_KWH" position="top" style={{ fill: "#0000ff", fontSize: 12, fontWeight: "bold" }} />
//                 </Bar>

//                 {/* PR (%) - Green Line */}
//                 <Line
//                   yAxisId="bottom"
//                   type="monotone"
//                   dataKey="MONTH_PR"
//                   stroke="green"
//                   name="MONTH_PR"
//                   strokeWidth={2}
//                 >
//                   <LabelList dataKey="MONTH_PR" position="top" style={{ fill: "green", fontSize: 12, fontWeight: "bold" }} />
//                 </Line>

//                 {/* ✅ Cumulative KWH - Red Line (Placed after bars to bring front) */}
//                 <Line
//                   yAxisId="left"
//                   type="monotone"
//                   dataKey="Plant_Total_KWH_Cumulative"
//                   stroke="red"
//                   name="Plant_Total_KWH_Cumulative"
//                   strokeWidth={2}
//                 >
//                   <LabelList dataKey="Plant_Total_KWH_Cumulative" position="top" style={{ fill: "red", fontSize: 12, fontWeight: "bold" }} />
//                 </Line>

//                 {/* Brush */}
//                 <Brush dataKey="MONTH" height={30} stroke="#8884d8" />
//               </ComposedChart>

//             </ResponsiveContainer>

//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default MonthlySumCurve;


import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  LabelList,
  Legend,
  Brush, // Import Brush for zoom functionality
} from "recharts";
import { InverterDetail2, MonthlySumApi } from "../../../../../../api/Api";
import { Refresh } from "@mui/icons-material"; // Import icons
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress"; // Loading spinner
import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

const MonthlySumCurve = () => {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const dashColor = LoggedInUserInfo?.dash_color || "#8884d8";
  const chartRef = useRef();
  const getCurrentMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const getSixMonthsAgo = () => {
    const now = new Date();
    now.setMonth(now.getMonth() - 5);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const [startDate, setStartDate] = useState(getSixMonthsAgo());
  const [endDate, setEndDate] = useState(getCurrentMonth());
  const [logData, setLogData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const credentials = {
    LOGIN_ID: localStorage.getItem("LoginID") || "",
    PASS_KEY: localStorage.getItem("KEY") || "xyz",
    LCODE: localStorage.getItem("LCODE") || "",
    MT1: startDate,
    MT2: endDate,
    TYP: "A",
    WEB_KEY: "WEBXYZ321",
    FID: "216HT001",
  };

  const fetchLogData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await MonthlySumApi(credentials);
      if (res?.MONTH_SUM && Array.isArray(res.MONTH_SUM)) {
        setLogData(res.MONTH_SUM);
        const transformed = res.MONTH_SUM.map((item) => ({
          MONTH: item.MONTH,
          Plant_Total_KWH_Cumulative: parseFloat(item.Plant_Total_KWH_Cumulative) || 0,
          MONTH_Total_KWH: parseFloat(item.MONTH_Total_KWH) || 0,
          EXPECTED_KWH: parseFloat(item.EXPECTED_KWH) || 0,
          MONTH_PR: parseFloat(item.MONTH_PR) || 0,
        }));
        setChartData(transformed);
      } else {
        setLogData([]);
        // console.error("Invalid response format");
      }
    } catch (err) {
      setError("Failed to fetch data");
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
  }, [startDate, endDate]);

  return (
    <div className="row">
      <div className="col-md-12" style={{ height: 480, position: "relative" }}>
        {/* Top Section */}
        <div style={containerStyle}>
                <p style={responsiveHeaderStyle}>Monthly Energy Summary Curve</p>
                <div style={responsiveControlsStyle}>
                    <label>
                        {/* From Date: */}
                        <input
                            type="month"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={inputStyle}
                        />
                    </label>
                    <label>
                        {/* To Date: */}
                        To
                        <input
                            type="month"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={inputStyle}
                        />
                    </label>
                    <button onClick={fetchLogData} style={buttonStyle}>
                        Show
                    </button>
                    <DownloadJpegButton targetRef={chartRef} fileName={`Monthly Energy Summary Curve.jpeg`} />
                </div>
            </div>


        {/* Chart */}
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress />
          </div>
        ) : (
          <ResponsiveContainer ref={chartRef}>
            <ComposedChart data={chartData} margin={{ top: 20, right: 100, left: 60, bottom: 20 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="MONTH" />

              {/* Left Y-Axis for Cumulative KWH */}
              <YAxis
                yAxisId="left"
                orientation="left"
                stroke="red"
                label={{
                  value: "",
                  angle: -90,
                  position: "outsideLeft",
                  fill: "red",
                  offset: 10,
                }}
              />

              {/* Right Y-Axis for Bar Graphs */}
              <YAxis
                yAxisId="right"
                orientation="right"
                stroke="#000"
                label={{
                  value: "",
                  angle: -90,
                  position: "outsideRight",
                  offset: 60,
                  fill: "#000",
                }}
              />

              {/* Right Y-Axis (secondary) for PR% */}
              <YAxis
                yAxisId="bottom"
                orientation="right"
                stroke="green"
                label={{
                  value: "",
                  angle: -90,
                  position: "outsideRight",
                  offset: 110,
                  fill: "green",
                }}
              />

              <Tooltip />
              <Legend verticalAlign="top" height={36} />

              {/* Bars - use shared right axis */}
              <Bar
                yAxisId="right"
                dataKey="MONTH_Total_KWH"
                fill={dashColor}
                name="MONTH_Total_KWH"
              >
                <LabelList dataKey="MONTH_Total_KWH" position="top" style={{ fill: dashColor, fontSize: 12, fontWeight: "bold" }} />
              </Bar>

              <Bar
                yAxisId="right"
                dataKey="EXPECTED_KWH"
                fill="#7692A2"
                name="Expected KWH"
              >
                <LabelList dataKey="EXPECTED_KWH" position="top" style={{ fill: "#7692A2", fontSize: 12, fontWeight: "bold" }} />
              </Bar>

              {/* Green Line for PR (%) */}
              <Line
                yAxisId="bottom"
                type="monotone"
                dataKey="MONTH_PR"
                stroke="green"
                name="MONTH_PR"
                strokeWidth={2}
              >
                <LabelList dataKey="MONTH_PR" position="top" style={{ fill: "green", fontSize: 12, fontWeight: "bold" }} />
              </Line>

              {/* Red Line for Cumulative KWH */}
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="Plant_Total_KWH_Cumulative"
                stroke="red"
                name="Plant_Total_KWH_Cumulative"
                strokeWidth={3}
              >
                <LabelList dataKey="Plant_Total_KWH_Cumulative" position="top" style={{ fill: "red", fontSize: 12, fontWeight: "bold" }} />
              </Line>

              <Brush dataKey="MONTH" height={30} stroke="#8884d8" />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default MonthlySumCurve;


const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  marginBottom: "7px",
  border: "1px solid lightgray",
  padding: "2px",
  borderRadius: "7px"
};

const responsiveHeaderStyle = {
  fontWeight: "bold",
  margin: "0",
};

const responsiveControlsStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
};

const inputStyle = {
  padding: "3px 6px",
  borderRadius: "14px",
  border: "1px solid #ccc",
  marginLeft: "5px",
  fontSize: "10px",
};

const buttonStyle = {
  backgroundColor: "#007BFF",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "2px 9px",
  cursor: "pointer",
  fontSize: "10px",
};